import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import action from '@flux/action';
import useTheme from '@hooks/useTheme';
import { Form, Input, Button } from 'antd';
import { individualBuyerData } from '@model/projectDetails';
import { scrollToTopAnimation } from '@utils/common';
const Item = Form.Item;
const { TextArea } = Input;
function ClientCompany(props) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const { saveData, saveCreateProjectData, steps } = props;
  const history = useHistory();
  const [form] = Form.useForm();
  const [scrollToTop] = useState();
  const data = {};

  useEffect(() => {
    scrollToTopAnimation({ y: 360 });
  }, [scrollToTop]);
  saveData.buyerCompanyInfo &&
    Object.keys(saveData.buyerCompanyInfo).forEach((item) => {
      if (
        item === 'employeeHeadcount' ||
        item === 'estimatedTotalRevenue' ||
        item === 'estimatedMarketCap'
      ) {
        data[`SUBONE${item}`] = saveData.buyerCompanyInfo[item]
          ? `${saveData.buyerCompanyInfo[item]}`.replace(
              /(\d)(?=(\d{3})+$)/g,
              '$1,',
            )
          : '';
      } else {
        data[`SUBONE${item}`] = saveData.buyerCompanyInfo[item];
      }
    });
  const renderItem = (item, idx) => {
    if (item.type === 'Input') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
          rules={[
            {
              required: item.required,
              whitespace: true,
              pattern: item.pattern,
              message: item.message,
            },
          ]}
        >
          <Input
            maxLength={255}
            onChange={(e) => {
              const itemName = item.name && item.name.substring(6);
              if (
                e.target.value &&
                (itemName === 'employeeHeadcount' ||
                  itemName === 'estimatedTotalRevenue' ||
                  itemName === 'estimatedMarketCap')
              ) {
                const num = e.target.value.replace(/,/g, '');
                form.setFieldsValue({
                  [item.name]: num.replace(/(\d)(?=(\d{3})+$)/g, '$1,'),
                });
                form.validateFields([item.name]);
              }
            }}
          />
        </Item>
      );
    } else if (item.type === 'Div') {
      return (
        <div
          style={{
            ...item.style,
            ...(isLightMode ? { color: '#474747' } : {}),
          }}
          key={item.name + idx}
        >
          {item.text}
          <span style={{ fontWeight: 700 }}>{item.companyName}</span>
        </div>
      );
    } else if (item.type === 'textArea') {
      return (
        <Item
          label={item.label}
          name={item.name}
          style={{ ...item.style }}
          key={item.name + idx}
        >
          <TextArea
            style={{ resize: 'none' }}
            // maxLength={255}
          />
        </Item>
      );
    }
    return null;
  };
  const commonData = (vals) => {
    const data = {
      buyerName: null,
      buyerCraftId: null,
      buyerCompanyInfo: {
        name: vals.SUBONEname,
        parentCompany: vals.SUBONEparentCompany || null,
        companyWebsite: vals.SUBONEcompanyWebsite || null,
        description: vals.SUBONEdescription || null,
        industry: vals.SUBONEindustry || null,
        headquarters: vals.SUBONEheadquarters || null,
        incorporationDate: vals.SUBONEincorporationDate || null,
        employeeHeadcount: vals.SUBONEemployeeHeadcount
          ? Number(vals.SUBONEemployeeHeadcount.replace(/,/g, ''))
          : null,
        estimatedTotalRevenue: vals.SUBONEestimatedTotalRevenue
          ? Number(vals.SUBONEestimatedTotalRevenue.replace(/,/g, ''))
          : null,
        estimatedMarketCap: vals.SUBONEestimatedMarketCap
          ? Number(vals.SUBONEestimatedMarketCap.replace(/,/g, ''))
          : null,
      },
      lastNum: 2,
      isEditing: saveData.stepOneFinish ? false : true,
    };
    return data;
  };

  const skipHandler = () => {
    const tempDataForSkip = {
      buyerName: null,
      buyerCraftId: null,
      buyerCompanyInfo: {
        name: null,
        parentCompany: null,
        companyWebsite: null,
        description: null,
        industry: null,
        headquarters: null,
        incorporationDate: null,
        employeeHeadcount: null,
        estimatedTotalRevenue: null,
        estimatedMarketCap: null,
      },
      lastNum: 2,
      isEditing: saveData.stepOneFinish ? false : true,
    };

    if (saveData.targetCheck) {
      // skip to target manual company page.
      saveCreateProjectData({
        ...tempDataForSkip,
        currentNum: 3,
        currentStep: 1,
      });
    } else {
      // skip to Team Detail page.

      saveCreateProjectData({
        ...tempDataForSkip,
        isEditing: true,
        currentStep: 2,
      });
      history.push(`/projects/create/${steps}`);
    }
  };

  const nextHandler = () => {
    form
      .validateFields()
      .then((vals) => {
        const data = commonData(vals);
        if (saveData.buyerCheck && saveData.targetCheck) {
          saveCreateProjectData({ ...data, currentNum: 3, currentStep: 1 });
        } else {
          saveCreateProjectData({
            ...data,
            currentStep: 2,
            isEditing: true,
          });
        }
      })
      .catch((err) => {
        scrollToTopAnimation({ y: 360 });
      });
  };

  return (
    <Form
      name="createProject"
      form={form}
      initialValues={data}
      layout="vertical"
      autoComplete="off"
    >
      {Array.isArray(individualBuyerData) &&
        individualBuyerData.map((item, idx) => renderItem(item, idx))}
      <div className="form-actions-wrapper">
        <Button className="ok-btn" onClick={nextHandler}>
          next
        </Button>
        <Button className="skip-btn" onClick={skipHandler}>
          skip
        </Button>

        <Button
          className="previous-btn"
          onClick={() => {
            const data = commonData(form.getFieldsValue());
            saveCreateProjectData({ ...data, currentNum: 1 });
          }}
        >
          previous
        </Button>
      </div>
    </Form>
  );
}

const mapStateToProps = ({ projects }) => ({
  saveData: projects.saveData,
});

const mapDispatchToProps = (dispatch) => ({
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ClientCompany));
